import { TrendingUp } from "lucide-react";

export default function BidLog({ logs }) {
  const reversed = (logs || []).slice().reverse();
  return (
    <div className="glass rounded-2xl p-5 sticky top-20 max-h-[80vh] flex flex-col">
      <div className="flex items-center gap-2 mb-4">
        <TrendingUp className="w-4 h-4 text-emerald-400" />
        <div className="label-eyebrow">Storico</div>
      </div>
      <div className="flex-1 overflow-y-auto scroll-thin space-y-2" data-testid="bid-log">
        {reversed.map((log, i) => (
          <LogRow key={`${log.ts}-${i}`} log={log} />
        ))}
        {(!logs || logs.length === 0) && (
          <div className="text-sm text-slate-500 italic">Nessuna attività ancora.</div>
        )}
      </div>
    </div>
  );
}

const LOG_STYLES = {
  assigned: "bg-emerald-500/10 border border-emerald-500/30",
  call:     "bg-blue-500/10 border border-blue-500/20",
  draw:     "bg-amber-500/10 border border-amber-500/20",
  tiebreak: "bg-amber-500/10 border border-amber-500/30",
  unsold:   "bg-slate-800/60 border border-white/5",
};
const LOG_FALLBACK = "bg-slate-900/40 border border-white/5";

function LogRow({ log }) {
  const cls = LOG_STYLES[log.type] || LOG_FALLBACK;
  return (
    <div className={`p-2 rounded-lg text-sm ${cls}`}>
      {log.type === "assigned" && (
        <span><b className="text-emerald-400">Aggiudicato!</b> {log.player_name} → {log.team_name} a <span className="font-mono">{log.amount} FM</span></span>
      )}
      {log.type === "call" && (
        <span>{log.team_name} chiama <b>{log.player_name}</b>{log.amount ? ` da ${log.amount} FM` : ""}</span>
      )}
      {log.type === "bid" && (
        <span>{log.team_name} rilancia <b>{log.player_name}</b> → <span className="font-mono text-emerald-400">{log.amount} FM</span></span>
      )}
      {log.type === "unsold" && (
        <span className="text-slate-400">Nessuna offerta per {log.player_name}</span>
      )}
      {log.type === "draw" && (
        <span><b className="text-amber-400">Sorteggio:</b> {log.order?.join(" → ")}</span>
      )}
      {log.type === "tiebreak" && (
        <span><b className="text-amber-400">Spareggio r{log.round}:</b> {log.player_name} — parità a {log.amount} FM tra {log.teams?.join(", ")}</span>
      )}
    </div>
  );
}
